export enum InspectionRequestedServicesEnum {
  T24 = 'T24',
  BPI = 'BPI',
  HES = 'HES'
}
